import { FC, useMemo } from 'react';
import { FormRadioGroup } from '../../common/form';
import { AlgorithmType } from './schema/zAlgorithmType';
import { useDataObjectFormLabelTranslation } from '../useDataObjectFormLabelTranslation';
import { DataObjectDescriptionVersionStore } from '../DataObjectDescriptionVersionStore';
import { DataObjectType } from '../../dataobject/types';

type Props = {
  name: string;
};

export const AlgorithmTypeSelect: FC<Props> = ({ name }) => {
  const { t: tLabel } = useDataObjectFormLabelTranslation();
  const [dataObjectDescriptionVersion] =
    DataObjectDescriptionVersionStore.useValue('dataObjectDescriptionVersion');

  const options = useMemo(() => {
    const opt = [
      {
        value: AlgorithmType.INSERT,
        label: tLabel('algorithms.type.I'),
      },
    ];

    if (dataObjectDescriptionVersion.dataObjectType === DataObjectType.IN) {
      opt.push({
        value: AlgorithmType.UPDATE_INDICATOR,
        label: tLabel('algorithms.type.UI'),
      });
    } else if (!dataObjectDescriptionVersion.requiredKeys?.length) {
      opt.push({
        value: AlgorithmType.UPDATE_DIMENSION,
        label: tLabel('algorithms.type.UD'),
      });
    }
    return opt;
  }, [
    dataObjectDescriptionVersion.dataObjectType,
    dataObjectDescriptionVersion.requiredKeys?.length,
    tLabel,
  ]);

  return <FormRadioGroup name={name} options={options} />;
};
